import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReferalState {
  mainAccount: boolean;
  userName: string;
  refresh?: boolean;
}

const initialState: ReferalState = {
  mainAccount: false,
  userName: "",
  refresh: false,
};

const referalSlice = createSlice({
  name: "referal",
  initialState,
  reducers: {
    setMainAccount(state, action: PayloadAction<boolean>) {
      state.mainAccount = action.payload;
    },
    setUserName(state, action: PayloadAction<string>) {
      state.userName = action.payload;
    },
    setRefresh(state, action: PayloadAction<boolean>) {
      state.refresh = action.payload;
    },
  },
});

export const { setMainAccount, setUserName, setRefresh } = referalSlice.actions;
export default referalSlice.reducer;
